import { isNullOrEmptyArray } from '@/helpers/array-helpers'
import BookingCoveringViewModel from './bookingCoveringViewModel'
import BookingCertificationViewModel from './bookingCertificationViewModel'
import BookingConfirmationViewModel from './bookingConfirmationViewModel'
import BookingClassificationViewModel from './bookingClassificationViewModel'
import BookingGradeViewModel from './bookingGradeViewModel'

/**
 * @typedef {Object} BookingDetailsViewModelType
 * @property {string} startTime - The start time of the booking
 * @property {string} endTime - The end time of the booking
 * @property {string} earliestDate - The date of the earliest booking within the booking group
 * @property {string} latestDate - The date of the latest booking within the booking group
 * @property {boolean} areDatesConsecutive - True if there are no working day gaps from the earliest booking to the latest booking in the group
 * @property {string} notes - Notes added to the booking
 * @property {string} room - Information on the room
 * @property {BookingCoveringViewModel} covering - The contact
 * @property {BookingClassificationViewModel} classification - The booking's classification
 */

/**
 * @class
 */
export default class BookingDetailsViewModel {
  /**
   * Create a new BookingDetailsViewModel.
   * @param {...BookingDetailsViewModelType} params
   */
  constructor(params) {
    this.startTime = params.startTime
    this.endTime = params.endTime
    this.earliestDate = params.earliestDate
    this.latestDate = params.latestDate
    this.areDatesConsecutive = params.areDatesConsecutive
    this.notes = params.notes
    this.room = params.room
    this.covering = params.covering
      ? new BookingCoveringViewModel(params.covering)
      : null
    this.certifications = !isNullOrEmptyArray(params.certifications)
      ? params.certifications.map(
          (certification) => new BookingCertificationViewModel(certification)
        )
      : []
    this.confirmations = !isNullOrEmptyArray(params.confirmations)
      ? params.confirmations.map(
          (confirmation) => new BookingConfirmationViewModel(confirmation)
        )
      : []
    this.classification = params.classification
      ? new BookingClassificationViewModel(params.classification)
      : null
    this.grades = !isNullOrEmptyArray(params.grades)
      ? params.grades.map(
          (confirmation) => new BookingGradeViewModel(confirmation)
        )
      : []
  }
}
